import { Button, Classes, Dialog, H4, Spinner, TextArea } from "@blueprintjs/core";
import truncate from "html-truncate";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { getTexts, updateItem } from "../../redux/actions/ikk/constPageData";
import { pageNames } from "../../utils/pageNames";
import MyCkEditor from "../common/MyCkEditor";
import TableActionButtons from "../common/TableActionButtons";
import { TableAdvanced } from "../common/TableAdvanced";

const SzakkepesitesStaticTexts = (props) => {
  const [rowEditing, setRowEditing] = useState(null); // selected row to edit
  const [page, setPage] = useState("szakkepesites");

  useEffect(() => {
    props.getTexts(page);
  }, [page]);

  const handleUpdate = async (e) => {
    await props.updateItem(rowEditing.page, rowEditing.id, rowEditing.value);
    await props.getTexts(page);
    setRowEditing(null);
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
      },
      {
        Header: "Kulcs",
        accessor: "key",
        Cell: ({ value }) => (
          <div style={{ wordBreak: "break-all", minWidth: "100px" }}>{value}</div>
        ),
      },
      {
        Header: "Szöveg",
        accessor: "value",
        Cell: ({ value }) => (
          <div
            style={{ maxWidth: "700px" }}
            dangerouslySetInnerHTML={{ __html: truncate(value, 150) }}
          />
        ),
      },
      {
        Header: "Oldal",
        accessor: "page",
        Cell: ({ value }) => pageNames[value] || value,
      },
      {
        Header: "Típus",
        accessor: "type",
        Cell: ({ value }) => (value === "TEXT" ? "Szöveg" : "HTML"),
      },
      {
        Header: "Utoljára módosítva",
        accessor: "updated_at",
        Cell: ({ value }) => new Date(value).toLocaleString(),
      },
      {
        Header: "Művelet",
        Cell: ({ row }) => (
          <TableActionButtons row={row} onEditBtnClick={setRowEditing} />
        ),
      },
    ],
    []
  );

  return (
    <>
      <h2>Összes statikus szöveg</h2>

      <Dialog
        onClose={() => setRowEditing(null)}
        transitionName={rowEditing?.type === "HTML" ? "" : undefined} // ckeditor's toolbar is collapsed if transition is not disabled
        style={{ width: "800px" }}
        title="Szöveg szerkesztése"
        isOpen={rowEditing !== null}
        usePortal={false}
        autoFocus={false}
        enforceFocus={false} //otherwise links are not editable
      >
        <div className={Classes.DIALOG_BODY}>
          <H4>{rowEditing?.key}</H4>

          {rowEditing?.type === "TEXT" ? (
            <TextArea
              fill
              growVertically={true}
              style={{ resize: "none" }}
              defaultValue={rowEditing?.value}
              onChange={(e) => {
                const { value } = e.target;
                console.log(value);
                setRowEditing((r) => ({ ...r, value: value }));
              }}
            />
          ) : (
            <div style={{ maxHeight: "70vh", overflowY: "auto" }}>
              <MyCkEditor
                removePlugins={["ImageUpload", "Image", "MediaEmbed", "Table"]}
                data={rowEditing?.value}
                onDataChange={(data) => setRowEditing((r) => ({ ...r, value: data }))}
              />
            </div>
          )}
        </div>

        <div className={Classes.DIALOG_FOOTER}>
          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button onClick={() => setRowEditing(null)}>Mégse</Button>
            <Button icon="floppy-disk" intent="success" onClick={handleUpdate}>
              Mentés
            </Button>
          </div>
        </div>
      </Dialog>

      {props.loading ? (
        <Spinner intent="primary" />
      ) : (
        <TableAdvanced columns={columns} data={props.texts} />
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  console.log(state.constPageData.texts);
  const { texts, loading } = state.constPageData;
  return { texts, loading };
};

export default connect(mapStateToProps, { getTexts, updateItem })(
  SzakkepesitesStaticTexts
);
